import React, { useMemo } from "react";
import { Box, TextField, MenuItem, Stack } from "@mui/material";
import { Search } from "@mui/icons-material";

const TransactionsFilters = ({ filters, onFiltersChange, isMobile, availableYears, availableMonths }) => {
  const statusOptions = [
    { value: "", label: "All" },
    { value: "PENDING", label: "Pending" },
    { value: "PAID", label: "Paid" },
  ];

  const monthOptions = [
    { value: "", label: "All Months" },
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const handleChange = (field, value) => {
    onFiltersChange({ ...filters, [field]: value });
  };

  return (
    <Stack spacing={2}>
      <Box
        display="flex"
        gap={2}
        flexDirection={isMobile ? "column" : "row"}
        flexWrap="wrap"
      >
        {/* Search */}
        <TextField
          placeholder="Search by date or week..."
          size="small"
          value={filters.search}
          onChange={(e) => handleChange("search", e.target.value)}
          InputProps={{
            startAdornment: <Search sx={{ mr: 1, color: "text.secondary" }} />,
          }}
          sx={{ minWidth: 240, flex: 1 }}
        />

        {/* Year Filter */}
        <TextField
          label="Year"
          select
          size="small"
          value={filters.year || ""}
          onChange={(e) => handleChange("year", e.target.value)}
          sx={{ minWidth: 120 }}
        >
          <MenuItem value="">All Years</MenuItem>
          {availableYears.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </TextField>

        {/* Month Filter */}
        <TextField
          label="Month"
          select
          size="small"
          value={filters.month || ""}
          onChange={(e) => handleChange("month", e.target.value)}
          sx={{ minWidth: 150 }}
        >
          {monthOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>

        {/* Status Filter */}
        <TextField
          label="Status"
          select
          size="small"
          value={filters.status}
          onChange={(e) => handleChange("status", e.target.value)}
          sx={{ minWidth: 150 }}
        >
          {statusOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </Stack>
  );
};

export default TransactionsFilters;
